import React, { CSSProperties, forwardRef } from "react";
import Search from "@ingka/search";
import "@ingka/svg-icon/dist/style.css";
import "@ingka/button/dist/style.css";
import "@ingka/search/dist/style.css";
import "@ingka/focus/dist/style.css";

export type FixaSearchActions = {
  onClick?: (e: React.MouseEvent) => void;
  text?: string;
  ssrIcon?: (prefix?: string) => React.SVGProps<SVGElement>[];
  disabled?: boolean;
  id?: string;
};

type FixaSearchProps = {
  id: string;
  className?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  onClear: (e: React.MouseEvent<HTMLButtonElement>) => void;
  value?: string;
  ariaLabel?: string;
  "data-testid"?: string;
  style?: CSSProperties;
  onClick?: React.MouseEventHandler<HTMLInputElement>;
  focusWithClearButton?: boolean;
  autoFocus?: boolean;
  onFocus?: () => void;
  onBlur?: () => void;
  actions?: FixaSearchActions[];
};

const FixaSearch = forwardRef<HTMLInputElement, FixaSearchProps>(
  (props, ref) => {
    return <Search ref={ref} {...props} />;
  }
);

export default FixaSearch;
